export default __webpack_public_path__ + "static/media/ahm-logo3.96a1df89.jpg";